// extracted by mini-css-extract-plugin
export default {"title":"_1e8d51b547","bld":"_20ef78d7bc"};